// Hotel closed for the season on a stay date (CU-869fmq3zd): the backend sends na=true + cause='closed'.
export const CLOSED_CAUSE = 'closed'

export const isClosedCause = cause => cause === CLOSED_CAUSE
